module.exports = {"pt-BR":{"components":{"datePicker":{"buttons":{"select":"Selecionar"}}}}}